






















import { Vue, Component } from "vue-property-decorator";

import Modal from "@/components/Modal.vue";

@Component({
  components: {
    Modal
  }
})
export default class PrivacyPolicy extends Vue {
  private isShown = false;

  private show() {
    this.$ga.event("menu", "click", "privacy-policy");
    this.isShown = true;
  }
}
